import React from 'react';
import './landing.css';
import AppearingElement from "../Helper/AppearingElement";
import vid from "./images/vid.webm";
import { Typography, Grid } from '@material-ui/core';
import logo from "../images/ziplyne-logo.png"


class TitlePage extends React.Component {
    render() {
        return (
            <div className="title-page">
                <Grid container
                    spacing={1}
                    justify="center"
                >
                    <Grid item xs={12} sm={12} md={12}>
                        <AppearingElement>
                            <img src={logo} alt="logo" className="title-page__logo"></img>
                            <Typography variant="h3" className="title-page__main-text">{this.props.title}</Typography>
                        </AppearingElement>
                        <AppearingElement>
                            <Typography variant="h4" className="title-page__sub-text">{this.props.subtitle}</Typography>
                        </AppearingElement>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}  >
                        <video className="title-page__video" src={vid} playsinline autoPlay muted loop></video>
                    </Grid>
                </Grid>
            </div>

        )
    }
}

export default TitlePage